<template>

    <v-modal title="Update Card">
        <template #body>
            <v-alert :message="error" />
            <form @submit.prevent="updatePaymentMethod">
                <v-input-card @error="error = $event" />
            </form>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="updatePaymentMethod">Update Card</v-button>
        </template>
    </v-modal>

</template>

<script>

import CompanyApi from '@api/CompanyApi';

export default {

    data() {
        return {
            loading: false,
            error: null,
            params: {},
        }
    },

    methods: {

        updatePaymentMethod() {
            this.loading = true;
            let stripe = this.$store.getters['stripe/stripe'];
            let card = this.$store.getters['stripe/card'];
            stripe.createToken(card).then((result) => {
                if (!result.error) {
                    this.params.stripe_token = result.token.id;
                    CompanyApi.updatePaymentMethod(this.$store.getters.company.id, this.params)
                        .then((response) => {
                            this.loading = false;
                            this.$emit('changed');
                            this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                            this.$store.commit('showModal', false);
                        }, (error) => {
                            this.loading = false;
                            this.error = error.response.data.message;
                        });
                } else {
                    this.loading = false;
                    this.error = result.error.message;
                }
            });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
